import Vue from 'vue'

export const CONFERENCE_SET_ROOMS = 'CONFERENCE_SET_ROOMS'
export const CONFERENCE_ADD_ROOM = 'CONFERENCE_ADD_ROOM'
export const CONFERENCE_UPDATE_ROOM = 'CONFERENCE_UPDATE_ROOM'
export const CONFERENCE_CLOSE_ROOM = 'CONFERENCE_CLOSE_ROOM'

export default {
  [CONFERENCE_SET_ROOMS]: (state, rooms) => {
    state.rooms = rooms
  },
  [CONFERENCE_ADD_ROOM]: (state, room) => {
    Vue.set(state.rooms, room.id, room)
  },
  [CONFERENCE_UPDATE_ROOM]: (state, room) => {
    Vue.set(state.rooms, room.id, room)
  },
  [CONFERENCE_CLOSE_ROOM]: (state, room) => {
    Vue.delete(state.rooms, room.id)
  }
}
